import { SubLayout } from '@/components/layouts'
const routes = {
  path: '/stat',
  redirect: '/stat/saleList',
  component: SubLayout,
  children: [
    {
      path: 'saleList',
      name: 'saleList',
      meta: {
        title: '销售统计'
      },
      component: () => import('@/views/stat/SaleList')
    }
  ]
}

export default routes
